var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn-vmodal btn btn-sm",on:{"click":function($event){return _vm.$modal.hide(_vm.name)}}},[_vm._v("\n    ❌\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }